import { theme } from 'abihome-components'

export default theme



// WEBPACK FOOTER //
// ./src/styles/theme.js